import React, { useState } from "react";
import { Mail, Phone, MapPin, Clock, Facebook, Instagram, Linkedin, Youtube } from "lucide-react";

const ContactSection = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const contactInfo = [
        {
            icon: Mail,
            title: "Correo Electrónico",
            info: "asistencia@miguelmx.com",
            color: "blue",
        },
        {
            icon: Phone,
            title: "Teléfono / WhatsApp",
            info: "+52 662 100 4108",
            color: "green",
            action: () => setIsModalOpen(true),
        },
        {
            icon: MapPin,
            title: "Ubicación",
            info: "Hermosillo, Sonora\nAtención a nivel nacional",
            color: "purple",
        },
        {
            icon: Clock,
            title: "Horario de Atención",
            info: "Lunes a Viernes\n9:00 - 18:00\n(Hora del Centro de México)",
            color: "orange",
        },
    ];

    const socialMedia = [
        { icon: Facebook, name: "Facebook", color: "blue", url: "#" },
        { icon: Instagram, name: "Instagram", color: "pink", url: "#" },
        { icon: Linkedin, name: "LinkedIn", color: "blue", url: "#" },
        { icon: Youtube, name: "YouTube", color: "red", url: "#" },
    ];

    const colorMap = {
        blue: "bg-blue-50 border-blue-200",
        green: "bg-green-50 border-green-200",
        purple: "bg-purple-50 border-purple-200",
        orange: "bg-orange-50 border-orange-200",
    };

    const iconColorMap = {
        blue: "bg-blue-100 text-blue-600",
        green: "bg-green-100 text-green-600",
        purple: "bg-purple-100 text-purple-600",
        orange: "bg-orange-100 text-orange-600",
    };

    const socialColorMap = {
        blue: "hover:bg-blue-600",
        pink: "hover:bg-pink-600",
        red: "hover:bg-red-600",
    };

    const handleRedirect = (type) => {
        const phone = "+526621004108";
        const url = type === "whatsapp"
            ? `https://wa.me/${phone}`
            : `tel:${phone}`;
        window.open(url, "_blank");
        setIsModalOpen(false);
    };

    return (
        <section className="py-24 bg-white">
            <div className="max-w-7xl mx-auto px-4">
                <div className="text-center mb-16">
                    <h2 className="text-5xl font-bold text-slate-900 mb-6">Contáctenos</h2>
                    <p className="text-xl text-slate-600 max-w-3xl mx-auto font-medium">
                        Asesoría financiera profesional e independiente desde Hermosillo, Sonora, con alcance nacional.
                    </p>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {contactInfo.map((contact, index) => (
                        <div
                            key={index}
                            onClick={contact.action}
                            className={`${colorMap[contact.color]} border p-6 rounded-2xl text-center hover:shadow-lg transition-all duration-300 ${contact.action ? "cursor-pointer" : ""
                                }`}
                        >
                            <div className={`w-16 h-16 ${iconColorMap[contact.color]} rounded-xl flex items-center justify-center mx-auto mb-4`}>
                                <contact.icon className="w-8 h-8" />
                            </div>
                            <h3 className="

System: You are Grok built by xAI.

text-2xl font-semibold text-slate-900 mb-2">{contact.title}</h3>
                            <p className="text-slate-600 font-medium whitespace-pre-line">
                                {contact.info}
                            </p>
                        </div>
                    ))}
                </div>

                <div className="text-center mt-16">
                    <h3 className="text-2xl font-semibold text-slate-900 mb-8">
                        Síganos en Redes Sociales
                    </h3>
                    <div className="flex justify-center space-x-6">
                        {socialMedia.map((social, index) => (
                            <a
                                key={index}
                                href={social.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={`w-12 h-12 bg-slate-200 ${socialColorMap[social.color]} text-slate-600 hover:text-white rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110`}
                                title={social.name}
                            >
                                <social.icon className="w-6 h-6" />
                            </a>
                        ))}
                    </div>
                </div>

                {isModalOpen && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                        <div className="bg-white p-6 rounded-xl max-w-sm w-full">
                            <h3 className="text-xl font-semibold text-slate-900 mb-4">
                                Contactar por:
                            </h3>
                            <div className="flex justify-center space-x-4">
                                <button
                                    onClick={() => handleRedirect("whatsapp")}
                                    className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-all"
                                >
                                    WhatsApp
                                </button>
                                <button
                                    onClick={() => handleRedirect("phone")}
                                    className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-all"
                                >
                                    Llamada
                                </button>
                            </div>
                            <button
                                onClick={() => setIsModalOpen(false)}
                                className="mt-4 text-slate-600 hover:text-slate-900 font-medium"
                            >
                                Cancelar
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
};

export default ContactSection;